Application.Signature.Color.Mover = {
    ui: {
        container: '.step-color__preview .preview',
        handle: '.preview .preview__transform-move',
        target: '.preview__logo',
        icon: '.step-preview__preview-icon-container'
    },
    color: null,
    x: 0,
    y: 0,
    scale: 1,
    ready: function (color) {

        this.color = color;

        // bind
        this.bind();

    },
    bind: function(){

        // move
        $(document).on('mousedown', this.ui.handle, this.onMoveStart.bind(this));
        $(document).on('touchstart', this.ui.handle, this.onMoveStart.bind(this));

        // transform stop
        this.color.Transformer.on('stop', this.reset.bind(this));

    },
    onMoveStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // set active
        $(self.ui.handle).addClass('.preview__transform-move_active');

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // handlers
        var move = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.move((x - x1) / self.scale, (y - y1) / self.scale);
            // update state
            x = x1;
            y = y1;
        };
        var moveEnd = function(){
            // remove active
            $(self.ui.handle).removeClass('.preview__transform-move_active');
            // unbind
            $(document).off('mousemove', move);
            $(document).off('touchmove', move);
            $(document).off('mouseup', moveEnd);
            $(document).off('touchend', moveEnd);
        };

        // bind
        $(document).on('mousemove', move);
        $(document).on('touchmove', move);
        $(document).on('mouseup', moveEnd);
        $(document).on('touchend', moveEnd);

    },
    move: function(x, y){

        // retrieve current values
        var $preview = $(this.ui.container);
        var $icon = $(this.ui.icon);

        // retrieve current values
        var padding = 30;
        var minY = $preview.offset().top + padding - $icon.height() * this.scale;
        var maxY = $preview.offset().top + $preview.height() - padding;
        var minX = $preview.offset().left + padding - $icon.width() * this.scale;
        var maxX = $preview.offset().left + $preview.width() - padding;

        // do not allow to pass the edge values
        var newX = this.x - x
        newX = $icon.offset().left - x > maxX ? this.x : newX;
        newX = $icon.offset().left - x < minX ? this.x : newX;
        var newY = this.y - y;
        newY = $icon.offset().top - y > maxY ? this.y : newY;
        newY = $icon.offset().top - y < minY ? this.y : newY;

        // update
        this.setPosition(newX, newY);

    },
    setPosition: function(x, y){

        this.x = x;
        this.y = y;

        $(this.ui.target).css({
            transform: 'translate(' + x + 'px, ' + y + 'px)'
        });

    },
    reset: function(){

        this.setPosition(0, 0);

    },
    setScale: function(scale){

        this.scale = scale;

    }
};